import styled from 'styled-components';

import { colors, fontSizes } from 'ui/theme';

import { EventInfo } from '../../../../domain';
import { HIDDEN_BY_GMAIL, TABLE_COLUMNS, UNKNOWN } from '../../constants';
import { UserAgentLabel } from './UserAgentLabel';
import { Cell } from '../../../../components/table';
import { getBrowser, getDevice, getOS, isGmailUserAgent } from '../../utils';

interface EventHistoryUserAgentsCellProps {
  userEvent: EventInfo;
}

type UATuple = {
  browser?: string;
  device?: string;
  os?: string;
};

export const userAgentToReadableName = (ua?: string): UATuple | false | undefined => {
  if (!ua) {
    return undefined;
  }
  if (isGmailUserAgent(ua)) {
    return false;
  }

  const browser = getBrowser(ua);
  const device = getDevice(ua);
  const os = getOS(ua);

  return { browser, device, os };
};

const NoUserAgents = styled.span`
  color: ${colors.textDisabled};
  font-size: ${fontSizes.s14};
`;

export const EventHistoryUserAgentCell = ({ userEvent }: EventHistoryUserAgentsCellProps) => {
  const userAgent = userAgentToReadableName(userEvent.userAgent);

  const notHidden = userAgent !== undefined;

  let uaInfo = <NoUserAgents data-test="user-agent-hidden-cell">{HIDDEN_BY_GMAIL}</NoUserAgents>;

  if (userAgent) {
    const { browser, device, os } = userAgent;
    const noAgents = browser === UNKNOWN && device === UNKNOWN && os === UNKNOWN;

    if (!noAgents) {
      uaInfo = (
        <div data-test="user-agent-label-cell">
          {<UserAgentLabel userAgent={`${browser}`} />} {' / '}
          {<UserAgentLabel userAgent={`${userEvent?.userAgentDevice || device}`} />} {' / '}
          {<UserAgentLabel userAgent={`${os}`} />}
        </div>
      );
    } else {
      uaInfo = <NoUserAgents data-test="user-agents-undefined">{UNKNOWN}</NoUserAgents>;
    }
  }

  return (
    <Cell
      columnId={TABLE_COLUMNS.SOURCES}
      data-test={notHidden ? 'user-agent-cell' : 'user-agent-empty-cell'}
    >
      {notHidden && uaInfo}
    </Cell>
  );
};
